// extracted by mini-css-extract-plugin
module.exports = {"ctaText":"_2aqHFS6i","title":"VbRGCSK8","intro":"_211CRnRB","subscribe":"_2sU9BF7E"};